// @ts-strict-ignore
/**
 * @fileoverview POST handler for the "/engagement/report_dashboard/run_dashboard/:dashboard_type(/:dashboard_id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { reportDashboardRunDashboardCacheKeys } from "./constants";
import type { PostReportDashboardRunDashboardProps } from "./types";

function toSnakeCase(props: PostReportDashboardRunDashboardProps) {
  const requestPayload = {
    app_group_id: props.appGroupId,
    start_date: props.startDate,
    end_date: props.endDate,
    variables: props.variables,
  };

  if (props.specificTdqIds) {
    requestPayload["specific_tdq_ids"] = props.specificTdqIds;
  }

  return requestPayload;
}

export const postReportDashboardRunDashboard = reactQueryMutationAdapter(
  reportDashboardRunDashboardCacheKeys,
  (props: PostReportDashboardRunDashboardProps): Promise<null> => {
    const url = props.dashboardId
      ? `/engagement/report_dashboard/run_dashboard/${props.dashboardType}/${props.dashboardId}`
      : `/engagement/report_dashboard/run_dashboard/${props.dashboardType}`;

    return fetch(url, "POST", toSnakeCase(props), null, {
      propagateFetchRequestError: false,
    });
  }
);
